import { cn } from '@mntn-dev/ui-utilities'
import { Skeleton } from '../../skeleton/skeleton.tsx'
import { type TagSize, tagSizeClassMap } from '../tag.tsx'

export type TagSkeletonProps = {
  className?: string
  size?: TagSize
}

export const TagSkeleton = ({ className, size = 'md' }: TagSkeletonProps) => {
  return <Skeleton className={cn('w-16', tagSizeClassMap[size], className)} />
}
